module.exports = __webpack_public_path__ + "img/c2.f89dcc5e.png";